(function(){
  'use strict';
  var CONFIG = [{"match":"section-collection-list","full":{"d":"texture","c":"cream","op":"wash"},"big":{"match":"section-collection-list","d":"flower","c":"lavender","w":440,"rot":-12,"anchor":"tr","dx":-20,"dy":0,"op":"ghost","h":441}},{"match":"section-featured-collection","nth":1,"big":{"match":"section-featured-collection","nth":1,"d":"spiral","c":"orange","w":380,"rot":18,"anchor":"tr","dx":-10,"dy":10,"op":"ghost","h":441}},{"match":"section-featured-collection","nth":2,"big":{"match":"section-featured-collection","nth":2,"d":"squiggle","c":"lavender","w":500,"rot":-6,"anchor":"br","dx":-40,"dy":-20,"op":"ghost","flip":1,"h":367}},{"match":"section-heritage","big":{"match":"section-heritage","d":"spiral","c":"light","w":340,"rot":24,"anchor":"br","dx":-180,"dy":-30,"op":"whisper","h":395}},{"match":"section-testimonials","big":{"match":"section-testimonials","d":"speech","c":"light","w":440,"rot":-8,"anchor":"br","dx":-40,"dy":-20,"op":"ghost","h":397}},{"match":"section-newsletter","big":{"match":"section-newsletter","d":"heart","c":"lavender","w":380,"rot":12,"anchor":"tr","dx":-30,"dy":-10,"op":"whisper","h":377}},{"match":"section-faq","big":{"match":"section-faq","d":"spiral","c":"lavender","w":420,"rot":14,"anchor":"br","dx":-30,"dy":-30,"op":"ghost","h":487}},{"match":"section-featured-blog","big":{"match":"section-featured-blog","d":"squiggle","c":"orange","w":500,"rot":6,"anchor":"tr","dx":-20,"dy":14,"op":"ghost","flip":1,"h":367}}];
  function makeDood(o){
    var s = document.createElement('span'); s.setAttribute('aria-hidden','true');
    s.className = 'bd bd-'+o.d+' bd--'+o.c+' bd--'+o.op;
    s.style.width = o.w+'px'; s.style.height = o.h+'px'; s.style.left='-9999px'; s.style.top='0px';
    s.style.transform = 'rotate('+(o.rot||0)+'deg)'+(o.flip?' scaleX(-1)':'');
    s.dataset.w = o.w; s.dataset.h = o.h; s.dataset.fw = o.fw; s.dataset.fh = o.fh;
    return s;
  }
  function content(sec){
    var sr = sec.getBoundingClientRect(), rects = [], secArea = sr.width*sr.height;
    function add(el){
      var cs = getComputedStyle(el); if (cs.visibility==='hidden' || cs.display==='none' || +cs.opacity===0) return;
      var r = el.getBoundingClientRect(); if (r.width<8 || r.height<7) return;
      if (r.width*r.height > secArea*0.5) return; // skip section-spanning containers
      rects.push({ l:r.left-sr.left, t:r.top-sr.top, r:r.right-sr.left, b:r.bottom-sr.top });
    }
    // media + form controls
    var media = sec.querySelectorAll('img,svg,picture,video,button,input,textarea,select,iframe,.btn');
    for (var i=0;i<media.length;i++){ var m=media[i]; if (!m.classList.contains('bd') && !m.closest('.bd')) add(m); }
    // any element that directly holds visible TEXT (headings, labels, links, stat numbers, spans...)
    var all = sec.querySelectorAll('*');
    for (var j=0;j<all.length;j++){
      var el = all[j]; if (el.classList.contains('bd') || el.closest('.bd')) continue;
      var hasText = false, cn = el.childNodes;
      for (var k=0;k<cn.length;k++){ if (cn[k].nodeType===3 && cn[k].textContent.replace(/\s/g,'').length>1){ hasText=true; break; } }
      if (hasText) add(el);
    }
    return { W: sr.width, H: sr.height, rects: rects };
  }
  // find an empty w x h spot avoiding content + already-placed doodles (avoid[]).
  function findSpot(c, avoid, w, h){
    var pad = 12, m = 16; // m = min clearance from content
    if (c.W < w+2*pad || c.H < h+2*pad) return null;
    var obstacles = c.rects.concat(avoid);
    var best=null, bestScore=-1e18, step=18;
    for (var ty=pad; ty+h<=c.H-pad; ty+=step){
      for (var tx=pad; tx+w<=c.W-pad; tx+=step){
        var bl=tx-m, bt=ty-m, br=tx+w+m, bb=ty+h+m, bad=false, minGap=1e9;
        for (var i=0;i<obstacles.length;i++){
          var rr=obstacles[i];
          if (bl<rr.r && rr.l<br && bt<rr.b && rr.t<bb){ bad=true; break; }
          var gx=Math.max(0, rr.l-br, bl-rr.r), gy=Math.max(0, rr.t-bb, bt-rr.b);
          var g=Math.sqrt(gx*gx+gy*gy); if (g<minGap) minGap=g;
        }
        if (bad) continue;
        var edge=Math.min(tx, c.W-(tx+w));        // near a side edge (margin feel)
        var topPen = ty<78 ? (78-ty)*2 : 0;        // clear the sticky nav strip
        var score = minGap - edge*0.5 - topPen;
        if (score>bestScore){ bestScore=score; best={left:tx, top:ty}; }
      }
    }
    return best;
  }
  function place(){
    var secs = document.querySelectorAll('#MainContent > .shopify-section[data-brave-decor]');
    for (var s=0;s<secs.length;s++){
      var sec = secs[s];
      var doods = [].slice.call(sec.querySelectorAll(':scope > .bd:not(.bd--full):not(.bd--big)'));
      var c = content(sec), placed = [];
      // place larger doodles first (harder to fit)
      doods.sort(function(a,b){ return (+b.dataset.w*+b.dataset.h) - (+a.dataset.w*+a.dataset.h); });
      for (var i=0;i<doods.length;i++){
        var el = doods[i], w=+el.dataset.w, h=+el.dataset.h, fw=+el.dataset.fw, fh=+el.dataset.fh;
        var spot = findSpot(c, placed, fw, fh);   // reserve the ROTATED footprint
        if (spot){ var lx=spot.left+(fw-w)/2, ly=spot.top+(fh-h)/2; el.style.left=Math.round(lx)+'px'; el.style.top=Math.round(ly)+'px'; placed.push({l:spot.left,t:spot.top,r:spot.left+fw,b:spot.top+fh}); }
        else { el.style.left='-9999px'; } // no room -> hide rather than sit on content
      }
    }
  }
  function inject(){
    var secs = document.querySelectorAll('#MainContent > .shopify-section');
    var occ={};
    for (var i=0;i<secs.length;i++){
      var sec=secs[i], marks={};
      for (var c=0;c<CONFIG.length;c++){ var mch=CONFIG[c].match; if (sec.className.indexOf(mch)!==-1 && !marks[mch]){ occ[mch]=(occ[mch]||0)+1; marks[mch]=occ[mch]; } }
      if (sec.getAttribute('data-brave-decor')) continue;
      // 'Hide background decoration' section setting: skip injection (nth counting above is kept
      // intact so the other featured-collection instance keeps its correct decoration).
      if (sec.querySelector('[data-no-decor]')) continue;
      var did=false;
      for (var c2=0;c2<CONFIG.length;c2++){
        var cfg=CONFIG[c2];
        if (sec.className.indexOf(cfg.match)===-1) continue;
        if (cfg.nth!=null && marks[cfg.match]!==cfg.nth) continue;
        if (!did){ sec.setAttribute('data-brave-decor','1'); sec.classList.add('brave-decor'); did=true; }
        if (cfg.full){ var f=document.createElement('span'); f.setAttribute('aria-hidden','true'); f.className='bd bd-'+cfg.full.d+' bd--'+cfg.full.c+' bd--'+cfg.full.op+' bd--full'; sec.appendChild(f); }
        if (cfg.big){ var o=cfg.big, b=document.createElement('span'); b.setAttribute('aria-hidden','true'); b.className='bd bd-'+o.d+' bd--'+o.c+' bd--'+o.op+' bd--big'; b.style.width=o.w+'px'; b.style.height=o.h+'px';
          if(o.anchor==='br'){b.style.right=(o.dx||0)+'px';b.style.bottom=(o.dy||0)+'px';} else if(o.anchor==='tr'){b.style.right=(o.dx||0)+'px';b.style.top=(o.dy||0)+'px';} else if(o.anchor==='bl'){b.style.left=(o.dx||0)+'px';b.style.bottom=(o.dy||0)+'px';} else {b.style.left=(o.dx||0)+'px';b.style.top=(o.dy||0)+'px';}
          b.style.transform='rotate('+(o.rot||0)+'deg)'+(o.flip?' scaleX(-1)':''); sec.appendChild(b); }
        (cfg.dood||[]).forEach(function(o){ sec.appendChild(makeDood(o)); });
      }
    }
  }
  function run(){ inject(); place(); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', place);
})();
